<template>
  <div>
    <Can action="view" subject="ad-manager.order">
      <AddNewOrderDialog
        :is-on="true"
        :is-loading="isAddingOrder"
        :on-cancel="onCancel"
        :on-confirm="createOrderFromDialog"
        :open-on-create="onCreated"
      />
    </Can>

    <Can action="view-business-contact" subject="ad-manager.order">
      <AddNewOrderStepper
        :promoted-deal="{}"
        :flow="flow"
        :on-cancel="onCancel"
        :on-confirm="createOrderFromStepper"
        :on-update="renameCreatedOrder"
        :on-create-li="createLineItem"
        :select-on-create="onCreated"
      />
    </Can>
  </div>
</template>

<script>
  import AddNewOrderDialog from '../../components/dialog/order/AddNew';
  import AddNewOrderStepper from '../../components/steppers/Promotion';

  export default {
    emits: ['saved'],
    components: {
      AddNewOrderDialog,
      AddNewOrderStepper,
    },
    data() {
      return {
        isAddingOrder: false,
        createdOrder: {},
      };
    },
    computed: {
      flow() {
        return this.$route.query.flow || '';
      },
    },
    methods: {
      onCancel() {
        // `flow` opened this dialog — it does not belong back on the list.
        const { flow, ...listQuery } = this.$route.query;
        this.$router.push({ name: 'promotions', query: listQuery });
      },
      onCreated(order) {
        if (order?.id) {
          this.$store.dispatch('promotions/getOrders', { page: 1, archived: 0, per_page: 15 }).catch((err) => err);
          this.$router.push({ name: 'promotion-details', params: { id: order.id }, query: this.$route.query });
        }
      },
      createOrderFromDialog(order) {
        this.isAddingOrder = true;

        return this.$store.dispatch('promotions/createOrder', order)
          .then(res => {
            if (res.success) {
              const { flow, ...listQuery } = this.$route.query;
              this.$emit('saved');
              this.$router.push({ name: 'promotions', query: listQuery });
            }

            return res;
          })
          .catch(err => err)
          .finally(() => {
            this.isAddingOrder = false;
          });
      },
      createOrderFromStepper(order) {
        this.isAddingOrder = true;

        return this.$store.dispatch('promotions/createOrder', order)
          .then(res => {
            if (res.success) {
              this.createdOrder = res.data.data.data;
            }

            return res;
          })
          .catch(err => err)
          .finally(() => {
            this.isAddingOrder = false;
          });
      },
      // The stepper's first step offers to rename the promotion it just created.
      renameCreatedOrder(order) {
        return this.$store.dispatch('promotions/updateOrder', { ...order, id: this.createdOrder.id, isBC: true })
          .then(res => {
            if (res.success) {
              this.createdOrder = res.data.data.data;
            }

            return res;
          })
          .catch(err => err);
      },
      createLineItem(lineItem) {
        return this.$store.dispatch('promotions/createLineItem', lineItem)
          .then(res => {
            this.$store.dispatch('promotions/getOrders', { page: 1, archived: 0, per_page: 15 }).catch((err) => err);
            return res;
          });
      },
    },
  };
</script>
